import styled, { css } from 'styled-components';
import 'keen-slider/keen-slider.min.css';

export const BannerHeading = styled.h1`
    font-size: 46px;
    line-height: 69px;
    font-weight: 600;
    margin: 0;
    margin-bottom: 30px;

    @media (max-width: 768px) {
        font-size: 33px;
        line-height: 42px;
    }

    @media (max-width: 375px) {
        font-size: 27px;
        line-height: 1.5;
    }
`;

export const SectionHeading = styled.h2`
    font-size: 34px;
    line-height: 48px;
    font-weight: 600;
    margin: 0;
    text-align: center;

    @media (max-width: 768px) {
        font-size: 25px;
        line-height: 37px;
    }

    @media (max-width: 375px) {
        font-size: 26px;
        line-height: 1.5;
    }
`;

export const Subtitle = styled.h3<{ $style: 'normal' | 'bold' }>`
    font-size: 18px;
    font-weight: 600;
    line-height: 27px;
    margin: 0;
    text-align: center;

    ${props =>
        props.$style === 'normal' &&
        css`
            font-weight: 400;
        `}

    ${props =>
        props.$style === 'bold' &&
        css`
            font-weight: 700;
        `}

    @media (max-width: 768px) {
        font-size: 16px;
        line-height: 24px;
    }
`;

export const HighlightText = styled.h4<{ $style: 'normal' | 'bold' }>`
    font-size: 18px;
    line-height: 27px;

    ${props =>
        props.$style === 'normal' &&
        css`
            font-weight: 400;
        `}

    ${props =>
        props.$style === 'bold' &&
        css`
            font-weight: 700;
        `}

  @media (max-width: 979px) {
        font-size: 16px;
        line-height: 24px;
    }
`;

export const Paragraph = styled.p<{
    $style: 'normal' | 'bold' | 'sliced' | 'quote';
    $small?: boolean;
}>`
    margin: 0;
    margin-bottom: 1.25rem;
    font-size: ${({ $style, $small }) => {
        if ($style === 'quote') {
            return '16px'; // Quote font size
        } else if ($small) {
            return '13px'; // Small font size
        } else {
            return '16px'; // Normal font size for other styles
        }
    }};
    line-height: ${({ $style, $small }) =>
        $style === 'quote'
            ? '25px' // Quote line height
            : $small
            ? '19px' // Small line height
            : '25px'}; // Line height for other styles
    font-weight: ${({ $style }) => {
        if ($style === 'bold') {
            return 700; // Bold font weight
        } else {
            return 400; // Normal font weight for other styles
        }
    }};
    font-style: ${({ $style }) =>
        $style === 'quote' ? 'italic' : 'normal'}; // Font style for quote style
    text-decoration-line: ${({ $style }) =>
        $style === 'sliced' ? 'strikethrough' : 'none'}; // Text decoration for sliced style
`;
